module.exports = __webpack_public_path__ + "static/media/14.20716be8.jpg";